// cache-and-network reports `loading: true` on every background revalidation,
// not just the first fetch — a spinner gated on raw `loading` would flicker
// on every refocus even though cached data is already rendered. Gate on
// "no data yet" instead so a cache hit still paints instantly (TA-10113).
export const isPendingSectionInitialLoading = (
  loading: boolean,
  data: unknown
): boolean => loading && !data;
